(function () {
    'use strict';

    var serviceId = 'restoreUserSvc';

    angular.module('app.security')
        .factory(serviceId, restoreUserSvc);

    restoreUserSvc.$inject = ['$location', '$q', 'appActivitySvc', 'userSvc'];
    function restoreUserSvc($location, $q, appActivitySvc, userSvc) {

        var service = {
            restore: restore
        };

        return service;

        function restore() {
            var deferred = $q.defer();
            var storedLang = window.lang || 'tr';
            appActivitySvc.busy("restoreUserSvc");
            var refreshToken = localStorage.getItem("refreshToken");
            if (refreshToken && !window.isHeadless()) {
                userSvc.getUserInfo().then(
                    function (result) {
                        if (result.information) {
                            deferred.resolve(true);
                        } else {
                            $location.path('/' + storedLang + "/signin");
                        }
                    },
                    function () {
                        deferred.reject(false);
                    })
                ['finally'](
                    function () {
                        appActivitySvc.idle("restoreUserSvc");
                    });
            } else {
                appActivitySvc.idle("restoreUserSvc");
                deferred.reject(false);
            }
            return deferred.promise;
        }
    }
})();